const STORAGE_KEY = 'cp.dashboard.weekly-days-vertical.v1';

/** 위클리 요일 블럭이 자동으로 세로 나열되는 뷰포트 폭 */
export const DASHBOARD_WEEKLY_DAYS_VERTICAL_MAX_WIDTH_PX = 1280;

export function readDashboardWeeklyDaysVerticalPref(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeDashboardWeeklyDaysVerticalPref(vertical: boolean): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, vertical ? '1' : '0');
  } catch {
    /* ignore */
  }
}

export function matchDashboardWeeklyDaysAutoVertical(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.matchMedia(
      `(max-width: ${DASHBOARD_WEEKLY_DAYS_VERTICAL_MAX_WIDTH_PX}px)`
    ).matches;
  } catch {
    return false;
  }
}
